import { addSharedStoreComponentLoader, importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentsMapping = {
  eventImageUploadAndCrop: defineAsyncComponent(() => importWithRetry(() => import('./upload-and-crop'))),
  eventPromptsBanner: defineAsyncComponent(() => importWithRetry(() => import('@/campaign-prompts/event-root')))
}

addSharedStoreComponentLoader(
  componentsMapping,
  {},
  () => importWithRetry(() => import('./store')),
  null
)
